import React from 'react';
import ListStory from '../../components/ListStory/ListStory';

const AskStory = () => {
  return <ListStory page={1} type="askstories" />;
};

export default AskStory;
